<div class="page">
  <div class="header">
    <button mat-icon-button mat-dialog-close>
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div>
      <h1>Pacientes atendidos</h1>
    </div>
  </div>

  @if (data.atendidos.length === 0) {
    <div class="sin-datos">
      <mat-icon class="material-symbols-outlined"> patient_list </mat-icon>

      <h2>No hay pacientes atendidos</h2>
    </div>
  } @else {
    <mat-dialog-content>
      <div class="detail-body">
        @for (p of data.atendidos; track p.id) {
          <div
            class="patient2"
            [class.clickable]="p.estado === 'EN_ATENCION'"
            [matTooltip]="p.estado === 'EN_ATENCION' ? 'Retomar consulta' : ''"
            (click)="retomarConsulta(p)"
          >
            <div class="patient-info">
              <strong>
                {{ p.paciente?.nombre }}
                {{ p.paciente?.apellido }}
              </strong>

              <small> Consulta general </small>
            </div>

            <span class="hora">
              {{ p.horaLlegada | date: 'HH:mm' }}
            </span>

            <div class="estado-wrapper">
              <span class="estado" [ngClass]="p.estado">
                {{ etiquetaEstado(p.estado) }}
              </span>
            </div>
          </div>
        }
      </div>
    </mat-dialog-content>
  }
</div>
